import { defineMessages } from 'react-intl';

const messages = defineMessages({
  defaultCarrierSharingButton: {
    defaultMessage: 'Default Carrier Sharing',
    id: 'gBTD7j',
    description: 'Default Carrier Sharing button label',
  },
  defaultCarrierSharingDescription: {
    defaultMessage:
      '<a>Configure your default shared carrier settings</a> or use the Actions menu to customize the settings for each vendor.',
    id: 'YgifD7',
    description: 'Default Carrier Sharing description',
  },
  adminModeInfo: {
    defaultMessage:
      'You can see Carrier Sharing configuration here because you are in admin mode (UI Carrier Sharing flag is currently disabled).',
    id: 'U8m3xw',
    description: 'Admin mode info',
  },
});

export default messages;
